/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Ai_Notice_DismissInputs */

const en_candidate_ai_notice_dismiss = /** @type {(inputs: Candidate_Ai_Notice_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss`)
};

const de_candidate_ai_notice_dismiss = /** @type {(inputs: Candidate_Ai_Notice_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausblenden`)
};

const fr_candidate_ai_notice_dismiss = /** @type {(inputs: Candidate_Ai_Notice_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masquer`)
};

const es_candidate_ai_notice_dismiss = /** @type {(inputs: Candidate_Ai_Notice_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar`)
};

const it_candidate_ai_notice_dismiss = /** @type {(inputs: Candidate_Ai_Notice_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi`)
};

const nl_candidate_ai_notice_dismiss = /** @type {(inputs: Candidate_Ai_Notice_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbergen`)
};

const pl_candidate_ai_notice_dismiss = /** @type {(inputs: Candidate_Ai_Notice_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamknij`)
};

const fi_candidate_ai_notice_dismiss = /** @type {(inputs: Candidate_Ai_Notice_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piilota`)
};

const da_candidate_ai_notice_dismiss = /** @type {(inputs: Candidate_Ai_Notice_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skjul`)
};

const sv_candidate_ai_notice_dismiss = /** @type {(inputs: Candidate_Ai_Notice_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dölj`)
};

/**
* | output |
* | --- |
* | "Dismiss" |
*
* @param {Candidate_Ai_Notice_DismissInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const candidate_ai_notice_dismiss = /** @type {((inputs?: Candidate_Ai_Notice_DismissInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Ai_Notice_DismissInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_ai_notice_dismiss(inputs)
	if (locale === "fr") return fr_candidate_ai_notice_dismiss(inputs)
	if (locale === "es") return es_candidate_ai_notice_dismiss(inputs)
	if (locale === "it") return it_candidate_ai_notice_dismiss(inputs)
	if (locale === "nl") return nl_candidate_ai_notice_dismiss(inputs)
	if (locale === "pl") return pl_candidate_ai_notice_dismiss(inputs)
	if (locale === "fi") return fi_candidate_ai_notice_dismiss(inputs)
	if (locale === "da") return da_candidate_ai_notice_dismiss(inputs)
	if (locale === "sv") return sv_candidate_ai_notice_dismiss(inputs)
	return en_candidate_ai_notice_dismiss(inputs)
});